import { defineStore } from "pinia";
import { PendingSignature } from "@/app/views/PdfViewer/domain/pending-signature.domain";

interface PendingSignaturesState {
  list: PendingSignature[];
}

export const usePendingSignaturesStore = defineStore("pending-signatures", {
  state: (): PendingSignaturesState => ({ list: [] }),
  actions: {
    setList(list: PendingSignature[]) {
      this.list = list;
    },
    add(pendingSignature: PendingSignature) {
      this.list = [...this.list, pendingSignature];
    },
    remove(pendingSignature: PendingSignature) {
      this.list = this.list.filter(item => item.idStr !== pendingSignature.idStr);
    },
  },
});
